/*
 * /document-writer — настоящие страницы на экране.
 *
 * Лист — один непрерывный contenteditable. Чтобы он выглядел и вёл себя как
 * стопка страниц с полями и промежутками (как у Word и Google Документов), а
 * строки переходили на следующую страницу там же, где они перейдут в PDF и при
 * печати, раскладка считается здесь и применяется ТОЛЬКО правилами CSS из
 * отдельного <style> — в документ не вставляется ни одного узла:
 *
 *   · строка, с которой начинается новая страница, — первая строка блока →
 *     блок получает padding-top ровно до начала области текста следующей
 *     страницы;
 *   · строка в середине абзаца → у абзаца появляется ::before c float и
 *     shape-outside: полоса во всю ширину, которая начинается у этой строки и
 *     выталкивает её (и всё ниже) на следующую страницу. Строки абзаца при этом
 *     не переразбиваются — сдвиг только по вертикали;
 *   · строка таблицы → её ячейки получают padding-top, а «огрызок» строки внизу
 *     прежней страницы закрывает полоса промежутка.
 *
 * Почему не узлы-распорки: вставка узла в абзац, в котором стоит каретка,
 * рвёт ввод с IME (корейский, японский), сбрасывает подчёркивание орфографии и
 * путает историю отмены. Правила CSS ничего из этого не задевают.
 *
 * Поверх листа (#dwGaps, вне документа) рисуются промежутки между страницами и
 * номера страниц. Тот же расчёт (`plan`) берёт выгрузка в PDF — страницы файла
 * совпадают со страницами на экране.
 *
 * Перенос строк по страницам — как у текстовых процессоров: заголовок не
 * остаётся последней строкой страницы (уходит вместе со следующей строкой),
 * абзац не оставляет внизу страницы одну свою первую строку.
 */
(function () {
'use strict';
var DW = window.DW;
if (!DW) return;

var doc = DW.doc, $ = DW.$;
var paper = $('dwPaper'), gapsEl = $('dwGaps'), styleEl = $('dwPaginate');
var GAP = 18;          // промежуток между листами на экране, px

var P = { pages: 1, cur: 1, timer: 0, first: 0, plan: null, busy: false, pending: false };

function lineHeightPx(el) {
    var cs = window.getComputedStyle(el);
    var lh = parseFloat(cs.lineHeight);
    if (isNaN(lh)) lh = parseFloat(cs.fontSize) * 1.15;
    return lh;
}

var BLOCK_RE = /^(P|H1|H2|H3|H4|H5|H6|LI|BLOCKQUOTE|PRE|TD|TH|DIV)$/;
function blockOf(n, rootEl) {
    var found = null;
    while (n && n !== rootEl) {
        if (n.nodeType === 1) {
            if (n.tagName === 'TABLE') return null;   // строки таблиц — неделимые единицы
            if (!found && BLOCK_RE.test(n.tagName) && !(n.tagName === 'DIV' && n.classList.contains('dw-toc'))) found = n;
        }
        n = n.parentNode;
    }
    return found;
}

/* Селектор узла через nth-child от корня — правила не требуют ни id, ни
   атрибутов на узлах документа. */
function selectorOf(el, rootEl, rootSel) {
    var parts = [];
    while (el && el !== rootEl) {
        var i = 1, s = el;
        while ((s = s.previousElementSibling)) i++;
        parts.unshift(':nth-child(' + i + ')');
        el = el.parentElement;
    }
    return rootSel + ' > ' + parts.join(' > ');
}

/* ── замер ───────────────────────────────────────────────────────────────
   Единицы раскладки в порядке сверху вниз: строки текста (сгруппированные по
   блоку), строки таблиц (неделимые), линии, разрывы страниц. Координаты — в
   CSS-пикселях листа от его верхнего края, независимо от масштаба экрана. */
function measure(rootEl, z) {
    var top0 = rootEl.getBoundingClientRect().top;
    var units = [];
    var byBlock = new Map();
    var range = document.createRange();
    function y(v) { return (v - top0) / z; }
    function addLine(block, r, kind) {
        if (r.height <= 0 && kind !== 'br') return;
        var lh = lineHeightPx(block), h = r.height / z;
        var hl = Math.max(0, (lh - h) / 2);
        var t = y(r.top) - hl, b = y(r.bottom) + hl;
        var list = byBlock.get(block);
        if (!list) { list = []; byBlock.set(block, list); }
        // та же строка — пересекается по вертикали больше чем наполовину
        for (var i = list.length - 1; i >= 0 && i >= list.length - 3; i--) {
            var L = list[i];
            var ov = Math.min(L.b, b) - Math.max(L.t, t);
            if (ov > Math.min(L.b - L.t, b - t) * 0.5) { L.t = Math.min(L.t, t); L.b = Math.max(L.b, b); return; }
        }
        list.push({ t: t, b: b });
    }
    function handleText(tn) {
        var v = tn.nodeValue;
        if (!v || !/[^\s\u200b]|\u00a0/.test(v)) return;
        var b = blockOf(tn, rootEl);
        if (!b) return;
        range.selectNodeContents(tn);
        var rs = range.getClientRects();
        for (var i = 0; i < rs.length; i++) addLine(b, rs[i], 'text');
    }
    (function walk(node) {
        for (var c = node.firstChild; c; c = c.nextSibling) {
            if (c.nodeType === 3) { handleText(c); continue; }
            if (c.nodeType !== 1) continue;
            var tg = c.tagName;
            if (tg === 'TABLE') {
                var rows = c.rows;
                for (var ri = 0; ri < rows.length; ri++) {
                    var rr = rows[ri].getBoundingClientRect();
                    units.push({ kind: 'row', el: rows[ri], table: c, t: y(rr.top), b: y(rr.bottom) });
                }
                continue;
            }
            if (tg === 'HR') {
                var hr = c.getBoundingClientRect();
                units.push({ kind: 'hr', el: c, t: y(hr.top) - 4, b: y(hr.bottom) + 4 });
                continue;
            }
            if (c.classList.contains('dw-pb')) {
                var pb = c.getBoundingClientRect();
                units.push({ kind: 'break', el: c, t: y(pb.top), b: y(pb.top) });
                continue;
            }
            if (tg === 'IMG' || tg === 'BR') {
                var bl = blockOf(c, rootEl);
                if (bl) {
                    var rects = c.getClientRects();
                    for (var k = 0; k < rects.length; k++) addLine(bl, rects[k], tg === 'BR' ? 'br' : 'img');
                }
                continue;
            }
            walk(c);
        }
    })(rootEl);
    // Пустые блоки (<p><br></p>, если у br нет прямоугольника) — строкой во весь блок.
    rootEl.querySelectorAll('p,h1,h2,h3,h4,li,blockquote,pre').forEach(function (b) {
        if (byBlock.has(b) || b.closest('table')) return;
        if (b.querySelector('p,h1,h2,h3,h4,li,ul,ol,table,blockquote')) return;
        var r = b.getBoundingClientRect();
        if (r.height <= 0) return;
        var cs = window.getComputedStyle(b);
        var pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
        byBlock.set(b, [{ t: y(r.top) + pt, b: y(r.bottom) - pb }]);
    });
    byBlock.forEach(function (lines, b) {
        lines.sort(function (a, c) { return a.t - c.t; });
        var head = /^H[1-6]$/.test(b.tagName);
        for (var i = 0; i < lines.length; i++) {
            units.push({ kind: 'line', block: b, idx: i, of: lines.length, head: head, t: lines[i].t, b: lines[i].b });
        }
    });
    units.sort(function (a, c) { return (a.t - c.t) || (a.kind === 'break' ? -1 : c.kind === 'break' ? 1 : 0); });
    return units;
}

/* ── расчёт страниц ─────────────────────────────────────────────────────── */
function plan(rootEl, set, z, gap) {
    gap = gap == null ? GAP : gap;
    var sz = DW.pageSizePx(set);
    var mt = set.m.t * DW.MM, mb = set.m.b * DW.MM;
    var ph = sz.h, contentH = ph - mt - mb;
    var slot = ph + gap;
    var T = function (k) { return k * slot + mt; };
    var units = measure(rootEl, z || 1);
    var pushes = [], k = 0, shift = 0, force = false;
    var pageFirst = [], lastBottom = [];
    // T(k) в координатах листа; единица u стоит на (u.t + shift)
    for (var i = 0; i < units.length; i++) {
        var u = units[i];
        if (u.kind === 'break') { force = true; continue; }
        var top = u.t + shift, bot = u.b + shift;
        var limit = T(k) + contentH;
        if (pageFirst[k] == null) {
            if (force) {
                var dF = T(k + 1) - top;
                if (dF > 0.5) { pushes.push({ u: u, d: dF }); shift += dF; k++; top += dF; bot += dF; }
                force = false;
            }
            pageFirst[k] = i;
            lastBottom[k] = bot;
            continue;
        }
        var over = bot > limit + 0.6;
        if (!over && !force) { lastBottom[k] = Math.max(lastBottom[k] || 0, bot); continue; }
        // начинаем новую страницу с u — или раньше, если так требует перенос
        var start = i;
        if (!force) {
            // абзац не оставляет внизу страницы одну свою первую строку
            if (u.kind === 'line' && u.idx === 1 && u.of > 2) {
                var p0 = i - 1;
                while (p0 >= 0 && !(units[p0].kind === 'line' && units[p0].block === u.block && units[p0].idx === 0)) p0--;
                if (p0 > pageFirst[k]) start = p0;
            }
            // заголовок не остаётся последней строкой страницы
            var j = start - 1;
            while (j > pageFirst[k] && units[j].kind === 'line' && units[j].head && units[j].idx === units[j].of - 1) {
                var h0 = j;
                while (h0 - 1 >= 0 && units[h0 - 1].kind === 'line' && units[h0 - 1].block === units[j].block) h0--;
                if (h0 <= pageFirst[k]) break;
                start = h0; j = h0 - 1;
            }
        }
        var su = units[start];
        var d = T(k + 1) - (su.t + shift);
        if (d < 0) d = 0;
        pushes.push({ u: su, d: d });
        shift += d;
        k++;
        pageFirst[k] = start;
        force = false;
        lastBottom[k] = bot + d;
        // единицы между start и i уже учтены сдвигом; пересчитать i не нужно —
        // они ушли вместе с su
    }
    var pages = k + 1;
    return { pushes: pushes, pages: pages, slot: slot, mt: mt, mb: mb, ph: ph, contentH: contentH, gap: gap, sz: sz };
}

/* ── правила CSS из плана ──────────────────────────────────────────────── */
function rules(pl, rootEl, rootSel) {
    var css = [];
    var bands = new Map();      // блок → [{top, h}] (в координатах блока)
    var blockShift = new Map(); // сколько сдвинут весь блок к моменту его первой строки
    var cum = 0;
    var rowFix = [];
    pl.pushes.forEach(function (p) {
        var u = p.u;
        if (u.kind === 'line' && u.idx > 0) {
            var b = u.block;
            var list = bands.get(b);
            if (!list) { list = []; bands.set(b, list); }
            list.push({ y: u.t, d: p.d, cumBefore: cum });
        } else if (u.kind === 'line') {
            var bt = window.getComputedStyle(u.block).paddingTop;
            css.push(selectorOf(u.block, rootEl, rootSel) + '{padding-top:calc(' + bt + ' + ' + p.d.toFixed(2) + 'px)!important}');
            blockShift.set(u.block, cum + p.d);
        } else if (u.kind === 'row') {
            var sel = selectorOf(u.el, rootEl, rootSel);
            var cells = u.el.cells;
            var pt = cells.length ? window.getComputedStyle(cells[0]).paddingTop : '0px';
            css.push(sel + ' > td,' + sel + ' > th{padding-top:calc(' + pt + ' + ' + p.d.toFixed(2) + 'px)!important}');
            rowFix.push({ row: u.el, table: u.table, y: u.t + cum, d: p.d });
        } else if (u.kind === 'hr') {
            css.push(selectorOf(u.el, rootEl, rootSel) + '{padding-top:' + p.d.toFixed(2) + 'px!important}');
        }
        cum += p.d;
    });
    // полосы внутри абзацев: верх полосы — в координатах самого блока
    bands.forEach(function (list, b) {
        var r0 = blockTopNatural(b, pl);
        var pts = [], acc = 0, h = 0;
        list.forEach(function (bd) {
            // сдвиг блока целиком к моменту его начала уже учтён в cumBefore
            // первой полосы минус сдвиги внутри блока
            var top = bd.y - r0.top + acc;
            pts.push([top, top + bd.d]);
            acc += bd.d;
            h = top + bd.d;
        });
        var poly = [];
        pts.forEach(function (p, i) {
            poly.push('0 ' + p[0].toFixed(2) + 'px', '100% ' + p[0].toFixed(2) + 'px', '100% ' + p[1].toFixed(2) + 'px', '0 ' + p[1].toFixed(2) + 'px');
        });
        css.push(selectorOf(b, rootEl, rootSel) + '::before{content:"";display:block;float:left;width:100%;height:' + h.toFixed(2) +
            'px;margin:0;padding:0;shape-outside:polygon(' + poly.join(',') + ');pointer-events:none}');
    });
    var minH = (pl.pages - 1) * pl.slot + pl.ph;
    css.push(rootSel + '{min-height:' + minH.toFixed(2) + 'px!important}');
    return { css: css.join('\n'), rowFix: rowFix };
}
/* Верх области содержимого блока в естественной раскладке (до наших правил). */
function blockTopNatural(b, pl) {
    return b.__dwTop || { top: 0 };
}

/* ── применение к живому листу ─────────────────────────────────────────── */
function zoomOf() {
    var w = doc.getBoundingClientRect().width, cw = DW.pageSizePx().w;
    return w > 0 && cw > 0 ? w / cw : 1;
}

function layoutLive() {
    P.timer = 0;
    if (DW.S.view !== 'page' || !doc.isConnected) { clearLive(); return; }
    if (DW.S.composing) { P.pending = true; return; }
    var t0 = performance.now();
    styleEl.textContent = '';
    var z = zoomOf();
    // естественные верхи блоков — для полос внутри абзацев
    stampTops(doc, z);
    var pl = plan(doc, DW.S.set, z, GAP);
    var out = rules(pl, doc, '#dwDoc');
    styleEl.textContent = out.css;
    P.plan = pl;
    P.pages = pl.pages;
    drawGaps(pl, out.rowFix);
    updateCurrent();
    var ms = performance.now() - t0;
    if (ms > 120) DW.track('paginate_slow', { ms: Math.round(ms), pages: pl.pages });
    DW.emit('pages', P.pages);
}
function stampTops(rootEl, z) {
    var top0 = rootEl.getBoundingClientRect().top;
    rootEl.querySelectorAll('p,h1,h2,h3,h4,h5,h6,li,blockquote,pre').forEach(function (b) {
        var r = b.getBoundingClientRect();
        var pt = parseFloat(window.getComputedStyle(b).paddingTop) || 0;
        b.__dwTop = { top: (r.top - top0) / z + pt };
    });
}
function clearLive() {
    styleEl.textContent = '';
    gapsEl.innerHTML = '';
    P.plan = null;
}

function pnLabel(n, total) { return String(n); }
function drawGaps(pl, rowFix) {
    var set = DW.S.set, h = [];
    var pn = set.pnum, skip = set.pnFirst;
    var mt = pl.mt, mb = pl.mb, slot = pl.slot, ch = pl.contentH;
    function label(n, y, pos) {
        if (pn === 'none' || (skip && n === 1)) return;
        var cls = pos.charAt(1) === 'c' ? 'c' : pos.charAt(1) === 'r' ? 'r' : 'l';
        h.push('<b class="' + cls + ' dw-pnum-l" style="top:' + y.toFixed(1) + 'px;position:absolute">' + pnLabel(n, pl.pages) + '</b>');
    }
    for (var k = 0; k < pl.pages; k++) {
        var top = k * slot;
        if (pn.charAt(0) === 't') label(k + 1, top + Math.max(6, mt / 2 - 6), pn);
        if (pn.charAt(0) === 'b') label(k + 1, top + mt + ch + Math.max(6, mb / 2 - 6), pn);
        if (k < pl.pages - 1) {
            var gTop = top + mt + ch;          // начало нижнего поля страницы k
            var gBot = (k + 1) * slot + mt;    // начало текста страницы k+1
            h.push('<div class="dw-gap" style="top:' + gTop.toFixed(1) + 'px;height:' + (gBot - gTop).toFixed(1) + 'px"><i style="top:' + (mb).toFixed(1) + 'px"></i></div>');
        }
    }
    // Строка таблицы, переехавшая на новую страницу: «огрызок» внизу прежней
    // страницы закрываем, сверху новой рисуем её верхнюю границу.
    var z = zoomOf();
    (rowFix || []).forEach(function (f) {
        var tr = f.table.getBoundingClientRect();
        var x0 = (tr.left - doc.getBoundingClientRect().left) / z, w = tr.width / z;
        var k = Math.floor((f.y + f.d) / slot);
        var gTop = (k - 1) * slot + mt + ch;
        var from = f.y + 1;
        if (from < gTop) h.push('<div class="dw-gap" style="top:' + from.toFixed(1) + 'px;height:' + (gTop - from).toFixed(1) + 'px;left:' + (x0 - 2).toFixed(1) + 'px;right:auto;width:' + (w + 4).toFixed(1) + 'px"></div>');
        var lineY = k * slot + mt - 1;
        h.push('<div class="dw-gap" style="top:' + lineY.toFixed(1) + 'px;height:1px;left:' + x0.toFixed(1) + 'px;right:auto;width:' + w.toFixed(1) + 'px;background:#7a7f87"></div>');
    });
    gapsEl.innerHTML = h.join('');
}

function updateCurrent() {
    var cur = 1;
    var r = DW.sel.range();
    if (r && P.plan) {
        var rects = r.getClientRects();
        var rr = rects.length ? rects[0] : r.getBoundingClientRect();
        if (rr && (rr.top || rr.height)) {
            var y = (rr.top - doc.getBoundingClientRect().top) / zoomOf();
            cur = Math.min(P.pages, Math.max(1, Math.floor((y + GAP / 2) / P.plan.slot) + 1));
        }
    }
    if (cur !== P.cur) { P.cur = cur; DW.emit('curpage', cur); }
}

/* Пересчёт по изменениям: не чаще раза в кадр, после паузы набора 120 мс, но
   не позже 450 мс от первой правки — длинная непрерывная печать тоже видит, где
   кончается страница. */
function schedule(now) {
    if (now) { clearTimeout(P.timer); P.first = 0; layoutLive(); return; }
    var t = Date.now();
    if (!P.first) P.first = t;
    clearTimeout(P.timer);
    var wait = Math.min(120, Math.max(0, 450 - (t - P.first)));
    P.timer = setTimeout(function () { P.first = 0; requestAnimationFrame(layoutLive); }, wait);
}

/* В виде «Текст» число страниц считается на невидимой копии листа той же
   ширины — счётчик честен и на телефоне. */
var shadow = null, shadowTimer = 0;
function shadowCount() {
    if (DW.S.view === 'page') return;
    clearTimeout(shadowTimer);
    shadowTimer = setTimeout(function () {
        try {
            var r = layoutClone({ keep: false });
            P.pages = r.pages;
            DW.emit('pages', P.pages);
        } catch (e) { DW.report(e, 'paginate_shadow'); }
    }, 900);
}

/* Копия листа в настоящей ширине страницы, вне экрана, с применёнными
   правилами страниц. Её же берёт выгрузка в PDF. */
function layoutClone(opts) {
    opts = opts || {};
    var host = document.createElement('div');
    host.setAttribute('aria-hidden', 'true');
    host.style.cssText = 'position:absolute;left:-30000px;top:0;width:' + DW.pageSizePx().w + 'px;visibility:hidden;pointer-events:none;contain:layout style;zoom:1';
    var c = doc.cloneNode(true);
    c.id = 'dwDocX';
    c.removeAttribute('contenteditable');
    c.style.cssText = doc.getAttribute('style') || '';
    c.style.boxShadow = 'none';
    var wrap = document.createElement('div');
    wrap.className = 'dw';
    wrap.setAttribute('data-view', 'page');
    wrap.style.cssText = 'height:auto;overflow:visible;border:0;box-shadow:none;background:none';
    wrap.appendChild(c);
    host.appendChild(wrap);
    document.body.appendChild(host);
    var st = document.createElement('style');
    document.head.appendChild(st);
    stampTops(c, 1);
    var pl = plan(c, DW.S.set, 1, opts.gap == null ? 0 : opts.gap);
    var out = rules(pl, c, '#dwDocX');
    st.textContent = out.css;
    var res = { pages: pl.pages, plan: pl, el: c, host: host, style: st };
    if (!opts.keep) { host.remove(); st.remove(); }
    return res;
}

DW.on('change', function () { if (DW.S.view === 'page') schedule(); else shadowCount(); });
DW.on('settings', function () { if (DW.S.view === 'page') schedule(true); else shadowCount(); });
DW.on('view', function () { if (DW.S.view === 'page') schedule(true); else { clearLive(); shadowCount(); } });
DW.on('zoom', function () { if (DW.S.view === 'page') schedule(true); });
DW.on('selection', function () { if (P.plan) updateCurrent(); });
if (document.fonts && document.fonts.addEventListener) {
    document.fonts.addEventListener('loadingdone', function () { if (DW.S.view === 'page') schedule(); else shadowCount(); });
}
doc.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') schedule(); }, true);

DW.paginate = {
    schedule: schedule, now: function () { schedule(true); }, layoutClone: layoutClone, plan: plan,
    pages: function () { return P.pages; }, current: function () { return P.cur; }, GAP: GAP,
    planNow: function () { return P.plan; }
};
})();
